import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NzDatePickerSizeType } from 'ng-zorro-antd/date-picker';

export type ILiberroDatePickerMode = 'date' | 'week' | 'month' | 'quarter' | 'range' | 'range-month';

@Component({
  selector: 'liberro-date-picker',
  standalone: false,
  templateUrl: './liberro-date-picker.component.html',
  styleUrl: './liberro-date-picker.component.less'
})
export class LiberroDatePickerComponent {
  @Input() public label = '';
  @Input() public placeholder = '';
  @Input() public value: Date | Date[] | null = null;
  @Input() public size: NzDatePickerSizeType = 'default';
  @Input() public mode: ILiberroDatePickerMode = 'date';
  @Input() public disabled = false;
  @Input() public customWidth = '';
  @Input() public customMargin = '';
  @Input() public minDate: Date | null = null;
  @Input() public maxDate: Date | null = null;
  @Input() public disabledDate: ((d: Date) => boolean) | undefined = undefined;

  @Output() public valueChange = new EventEmitter<Date | Date[] | null>();
  @Output() public openChange = new EventEmitter<boolean>();

  public onValueChange(value: Date | Date[] | null): void {
    this.valueChange.emit(value);
  }

  public onOpenChange(isOpen: unknown): void {
    this.openChange.emit(!!isOpen);
  }

  public getRangePlaceholder(): string[] {
    if (this.placeholder && (this.placeholder.includes('→') || this.placeholder.includes('\u2192') || this.placeholder.includes('->'))) {
      let separator = '→';
      if (this.placeholder.includes('→')) {
        separator = '→';
      } else if (this.placeholder.includes('\u2192')) {
        separator = '\u2192';
      } else if (this.placeholder.includes('->')) {
        separator = '->';
      }
      const parts = this.placeholder.split(separator).map(p => p.trim());
      const result = parts.length === 2 ? parts : [this.placeholder, this.placeholder];
      return result;
    }
    if (this.placeholder) {
      return [this.placeholder, this.placeholder];
    }
    return ['Od', 'Do'];
  }

  public getDisabledDate = (current: Date): boolean => {
    if (this.minDate) {
      const minYear = this.minDate.getFullYear();
      const minMonth = this.minDate.getMonth();
      const currentYear = current.getFullYear();
      const currentMonth = current.getMonth();

      if (currentYear < minYear || (currentYear === minYear && currentMonth < minMonth)) {
        return true;
      }
    }

    if (this.maxDate) {
      const maxYear = this.maxDate.getFullYear();
      const maxMonth = this.maxDate.getMonth();
      const maxDay = this.maxDate.getDate();
      const currentYear = current.getFullYear();
      const currentMonth = current.getMonth();
      const currentDay = current.getDate();

      if (currentYear > maxYear ||
          (currentYear === maxYear && currentMonth > maxMonth) ||
          (currentYear === maxYear && currentMonth === maxMonth && currentDay > maxDay)) {
        return true;
      }
    }

    return false;
  }
}
